import { formatCurrency } from "../../utils/currency";
import { textStyles } from "../../styles/typography";
import { ccn } from "../../styles/utils";
import Button from "../ui/Button";
import { Spinner } from "../ui/Loading";

export default function SlotComponent({
  title,
  fromToTime,
  price,
  disabled,
  loading,
  handleBook,
  currency = "USD",
  locale = "en-US",
}: {
  fromToTime: string;
  price?: number | null;
  disabled?: boolean;
  loading?: boolean;
  handleBook: () => void;
  title: string;
  currency?: string;
  locale?: string;
}) {
  return (
    <div className="widget-slot flex items-center justify-between">
      <div className="widget-slot__info">
        <div
          className={ccn(
            textStyles.sub1,
            "widget-slot__time text-blue-dark",
            "mb-1",
          )}
        >
          {fromToTime}{" "}
        </div>{" "}
        <div
          className={ccn(
            textStyles.label,
            "widget-slot__title text-blue-dark60",
          )}
        >
          {title}
        </div>
        {/* {!loading && !disabled && <div>{formatCurrency(price ?? 0, currency, locale)}</div>} */}
      </div>

      <div className="widget-slot__action">
        {disabled ? (
          <Button type="button" variant="primary" small disabled>
            Sold Out
          </Button>
        ) : loading ? (
          <Spinner />
        ) : (
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              window.scrollTo(0, 0);
              handleBook();
            }}
            small
          >
            Book for {formatCurrency(price ?? 0, currency, locale)}*
          </Button>
        )}
      </div>
    </div>
  );
}
